import React from "react"
import { Container, Input, PhoneNumber, MultiSelect, Button } from "../index"
import { useForm, Controller } from "react-hook-form"
import { useModel } from "../../context"

export const Login = () => {
  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({ name: "", password: "" })
  const submitHandler = (data) => {
    console.log(data)

    setTimeout(() => {
      reset({ name: "", password: "" })
    }, 2000)
  }
  const { toggleIsModel } = useModel()
  const handleModel = () => {
    toggleIsModel()
  }

  const handleFormClick = (e) => {
    e.stopPropagation()
  }
  return (
    <div
      className="absolute z-[80] bg-black bg-opacity-40 h-screen w-full flex justify-center items-center"
      onClick={handleModel}
    >
      <form
        onSubmit={handleSubmit(submitHandler)}
        onClick={handleFormClick}
        className="bg-[#E1FBF7] h-[80%] px-20 flex flex-col justify-center items-center rounded-lg"
      >
        <h1 className="text-2xl md:3xl lg:text-4xl leading-[1.2] font-roboto mb-3 text-darkGray font-bold">
          Login in to your account
        </h1>
        <div className="flex flex-col w-[100%] mt-8">
          <div className="">
            {/* EMAIL */}
            <div className="mb-4 w-full">
              <Input
                labelColor="text-darkGray"
                className="text-darkGray border-darkGray border focus:border-darkBlackgreen  outline-none placeholder:text-darkGray"
                name="email"
                label="Work Email"
                type="text"
                placeholder="Enter your email"
                autoComplete="off"
                {...register("email", {
                  required: true,
                  validate: {
                    matchPattern: (value) =>
                      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(
                        value
                      ) || "Not a valid email",
                  },
                })}
              />
              {errors.email?.type === "required" && <p className="text-red-600 ml-2 text-sm">Work email is required</p>}
              {errors.email?.type === "matchPattern" && (
                <p className="text-red-600 ml-2 text-sm">{errors.email?.message}</p>
              )}
            </div>
            {/* EMAIL */}
            <div className="mb-4 w-full">
              <Input
                labelColor="text-darkGray"
                className="text-darkGray border-darkGray border focus:border-darkBlackgreen  outline-none placeholder:text-darkGray"
                name="password"
                label="Password"
                type="text"
                placeholder="Enter password"
                autoComplete="off"
                {...register("password", {
                  required: true,
                })}
              />
              {errors.password?.type === "required" && (
                <p className="text-red-600 ml-2 text-sm">Password is required</p>
              )}
            </div>

            <div className="className mt-6 w-full">
              <Button bgColor="bg-darkBlackgreen" className="w-full py-2 rounded font-roboto text-base" type="submit">
                Submit
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
